import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, type Envelope } from '@/lib/apiClient';
import type { MeDTO } from '@/types/api';
import { useAuthStore } from '@/stores/authStore';

async function fetchMe(): Promise<MeDTO> {
  const res = await api.get<Envelope<MeDTO>>('/api/v1/me');
  return res.data.data;
}

export function useMe() {
  const setUser = useAuthStore((s) => s.setUser);
  const setStatus = useAuthStore((s) => s.setStatus);

  const query = useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
    retry: false,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (query.data) setUser(query.data);
    else if (query.isError) setStatus('unauthenticated');
  }, [query.data, query.isError, setUser, setStatus]);

  return query;
}
